import { render, staticRenderFns } from "./ShiftNew.vue?vue&type=template&id=416aab08&scoped=true&"
import script from "./ShiftNew.vue?vue&type=script&lang=js&"
export * from "./ShiftNew.vue?vue&type=script&lang=js&"
import style0 from "./ShiftNew.vue?vue&type=style&index=0&id=416aab08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416aab08",
  null
  
)

export default component.exports